var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5041_11320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7128 15.0903L16.4734 17.569C16.4247 17.6228 16.3658 17.6657 16.3004 17.6951C16.2349 17.7244 16.1643 17.7396 16.093 17.7395H5.47736C5.42671 17.7395 5.37716 17.7242 5.33481 17.6956C5.29245 17.6669 5.25913 17.6261 5.23894 17.5781C5.21875 17.5302 5.21257 17.4772 5.22116 17.4257C5.22975 17.3742 5.25273 17.3264 5.28729 17.2881L7.52833 14.8094C7.57688 14.7557 7.63559 14.7129 7.70082 14.6836C7.76607 14.6542 7.83645 14.639 7.90762 14.6389H18.5226C18.5733 14.6389 18.6228 14.6542 18.6652 14.6828C18.7075 14.7115 18.7408 14.7523 18.7611 14.8003C18.7813 14.8482 18.7874 14.9012 18.7788 14.9527C18.7703 15.0042 18.7473 15.052 18.7128 15.0903ZM16.4734 10.0989C16.4247 10.045 16.3658 10.0021 16.3004 9.97275C16.2349 9.94342 16.1643 9.9283 16.093 9.92834H5.47736C5.42671 9.92834 5.37716 9.94361 5.33481 9.97228C5.29245 10.0009 5.25913 10.0418 5.23894 10.0897C5.21875 10.1377 5.21257 10.1906 5.22116 10.2422C5.22975 10.2937 5.25273 10.3415 5.28729 10.3797L7.52833 12.8584C7.57688 12.9121 7.63559 12.955 7.70082 12.9843C7.76607 13.0136 7.83645 13.0288 7.90762 13.0289H18.5226C18.5733 13.0289 18.6228 13.0137 18.6652 12.985C18.7075 12.9563 18.7408 12.9155 18.7611 12.8676C18.7813 12.8196 18.7874 12.7666 18.7788 12.7151C18.7703 12.6636 18.7473 12.6158 18.7128 12.5776L16.4734 10.0989ZM5.47736 8.3184H16.093C16.1643 8.31843 16.2349 8.30331 16.3004 8.27397C16.3658 8.24463 16.4247 8.2017 16.4734 8.14786L18.7128 5.66915C18.7473 5.63093 18.7703 5.58312 18.7788 5.5316C18.7874 5.48008 18.7813 5.42709 18.7611 5.37914C18.7408 5.3312 18.7075 5.29038 18.6652 5.26172C18.6228 5.23305 18.5733 5.21778 18.5226 5.21777H7.90762C7.83645 5.2179 7.76607 5.2331 7.70082 5.26243C7.63559 5.29177 7.57688 5.33461 7.52833 5.38831L5.28787 7.86702C5.25334 7.90519 5.23037 7.95296 5.22176 8.00442C5.21315 8.05588 5.21928 8.10883 5.2394 8.15675C5.25952 8.20468 5.29275 8.24549 5.33502 8.2742C5.37729 8.30292 5.42676 8.31827 5.47736 8.3184Z",
    fill: "url(#paint0_linear_5041_11320)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5041_11320",
    x1: 6.36245,
    y1: 18.0379,
    x2: 17.8897,
    y2: 5.44752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5041_11320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5652,
    height: 12.5217,
    fill: "white",
    transform: "translate(5.21739 5.21777)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolM);
export default __webpack_public_path__ + "static/media/sol-m.b1c9a214a609847d2f653561c27a02d3.svg";
export { ForwardRef as ReactComponent };